<template>
  <div class="home-warp ">
    <Alert :show.sync="alertShow" :title="alertTitle" :content="alertContent" :transify="transify" :add-ga="addGA" />
    <ws-header
      :title="transify['WISHING_TITLE']"
      :userInfo="userInfo"
      :rightShow="'id'"
      :EvtQuestion="EvtQuestion"
    ></ws-header>
    <div class="home">
      <div class="left">
        <div class="tab-menu" @click="chooseTab">
          <!-- tab头部 -->
          <div data-tab="1" class="tab tab1 background-set-cover" :class="[{ 'tab1-check': currentTabIndex === '1' }]">
            <i data-tab="1" class="red-icon" v-show="!tabCheckRecord['1']['status'] && currentTabIndex !== '1'"></i>
          </div>
          <div data-tab="2" class="tab tab2 background-set-cover" :class="{ 'tab2-check': currentTabIndex === '2' }">
            <i data-tab="2" class="red-icon" v-show="!tabCheckRecord['2']['status'] && currentTabIndex !== '2'"></i>
          </div>
          <div data-tab="3" class="tab tab3 background-set-cover" :class="{ 'tab3-check': currentTabIndex === '3' }">
            <i data-tab="3" class="red-icon" v-show="!tabCheckRecord['3']['status'] && currentTabIndex !== '3'"></i>
          </div>
          <div data-tab="4" class="tab tab4 background-set-cover" :class="{ 'tab4-check': currentTabIndex === '4' }">
            <i data-tab="4" class="red-icon" v-show="!tabCheckRecord['4']['status'] && currentTabIndex !== '4'"></i>
          </div>
          <!-- 内容 -->
          <div class="tab-content background-set-full">
            <!-- tab1 -->
            <div class="item-warp" v-show="currentTabIndex === '1'">
              <div
                :class="{
                  'item-gray': tabCheckRecord['1']['status'] && !item.checked,
                }"
                class="item-bg background-set-full"
                @click="checkItems('1', item)"
                v-for="(item, index) in itemCollections1"
                :key="'tab1' + index"
              >
                <img class="item " :src="item.img" />
                <i class="unCheck background-set-full" :class="{ check: item.checked }"></i>
                <span class="item_num" v-show="item.num > 1">x{{ item.num }}</span>
              </div>
            </div>
            <!-- tab2 -->
            <div class="item-warp" v-show="currentTabIndex === '2'">
              <div
                :class="{
                  'item-gray': tabCheckRecord['2']['status'] && !item.checked,
                }"
                class="item-bg background-set-full"
                @click="checkItems('2', item)"
                v-for="(item, index) in itemCollections2"
                :key="'tab2' + index"
              >
                <img class="item " :src="item.img" />
                <i class="unCheck background-set-full" :class="{ check: item.checked }"></i>
                <span class="item_num" v-show="item.num > 1">x{{ item.num }}</span>
              </div>
            </div>
            <!-- tab3 -->
            <div class="item-warp" v-show="currentTabIndex === '3'">
              <div
                :class="{
                  'item-gray': tabCheckRecord['3']['status'] && !item.checked,
                }"
                class="item-bg background-set-full"
                @click="checkItems('3', item)"
                v-for="(item, index) in itemCollections3"
                :key="'tab3' + index"
              >
                <img class="item " :src="item.img" />
                <i class="unCheck background-set-full" :class="{ check: item.checked }"></i>
                <span class="item_num" v-show="item.num > 1">x{{ item.num }}</span>
              </div>
            </div>
            <!-- tab4 -->
            <div class="item-warp" v-show="currentTabIndex === '4'">
              <div
                :class="{
                  'item-gray': tabCheckRecord['4']['status'] && !item.checked,
                }"
                class="item-bg background-set-full"
                @click="checkItems('4', item)"
                v-for="(item, index) in itemCollections4"
                :key="'tab3' + index"
              >
                <img class="item " :src="item.img" />
                <i class="unCheck background-set-full" :class="{ check: item.checked }"></i>
                <span class="item_num" v-show="item.num > 1">x{{ item.num }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <!-- 选中物品 -->
        <div class="item-warp checked-items">
          <div class="item-bg background-set-full" v-for="(chosen, index) in [0, 1, 2, 3]" :key="'chosen' + index">
            <img v-if="checkedItems.length > chosen" class="item" :src="pkToItem(checkedItems[index])['img']" />
            <img v-else class="item-static" src="../../../static/images/itemStatic.png" />
            <span class="item_num" v-show="pkToItem(checkedItems[index])['num'] > 1"
              >x{{ pkToItem(checkedItems[index])['num'] }}</span
            >
          </div>
        </div>
        <!-- 说明 -->
        <div class="guide background-set-full">
          <article class="content">
            {{ transify['WISHING_GUIDE'] }}
          </article>
        </div>
        <div
          @click="EvtShowConfirm"
          class="enter background-set-full"
          :class="{ 'enter-gold': checkedItems.length === 4 }"
        >
          <div :data-text="transify['WISHING_ENTER']" :class="{ 'enter-gold-text': checkedItems.length === 4 }">
            {{ transify['WISHING_ENTER'] }}
          </div>
        </div>
      </div>
    </div>
    <!-- 选中后二次确认 -->
    <ws-dialog :show.sync="chosenConfirm" :closeAble="true" :beforeClose="beforeCloseConfirm">
      <!-- 选中物品 -->
      <template slot="content">
        <div class="chosen-title">
          {{ transify['WISHING_CONFIRM_TIPS'] }}
        </div>
        <div class="chosen-confirm">
          <div class="item-bg background-set-full" v-for="(chosen, index) in [0, 1, 2, 3]" :key="'chosen' + index">
            <img class="item" :src="pkToItem(checkedItems[index])['img']" />
            <div class="item-name">
              <p v-marquee v-if="chosenConfirm">
                <span>{{ pkToItem(checkedItems[index])['name'] }}</span>
              </p>
            </div>
            <span class="item_num" v-show="pkToItem(checkedItems[index])['num'] > 1"
              >x{{ pkToItem(checkedItems[index])['num'] }}</span
            >
          </div>
          <div class="chosen-confirm-btn">
            <div class="confirm-btn background-set-full confirm-btn-cancel" @click="beforeCloseConfirm">
              <div class="skew-15">{{ transify['WISHING_CONFIRM_AGAIN'] }}</div>
            </div>
            <div class="confirm-btn background-set-full confirm-btn-ok" @click="EvtGoTask">
              <div class="confirm-btn-ok-txt skew-15">{{ transify['WISHING_CONFIRM_OK'] }}</div>
            </div>
          </div>
        </div>
      </template>
    </ws-dialog>
    <!-- 规则弹窗 -->
    <ws-dialog :show.sync="ruleShow" :closeAble="true">
      <div slot="content" class="can-scoll-y" v-html="rule" style="color:#d9ca96;"></div>
    </ws-dialog>
  </div>
</template>

<script>
import wsHeader from '../../components/productComponents/wsHeader'
import utils from '../../utils/common'
import Alert from '../../components/alert/Alert.vue'
import gaTool from '../../utils/ga'
export default {
  name: 'home',
  components: {
    wsHeader,
    Alert,
  },
  data() {
    return {
      alertShow: false,
      alertTitle: '',
      alertContent: '',
      pkMap: {},
      userInfo: null,
      guide: '',
      rule: '',
      checkedItems: [], //选中物品
      // 判断是否有选中物品
      tabCheckRecord: {
        '1': {
          status: false,
          arraryPos: -1,
        },
        '2': {
          status: false,
          arraryPos: -1,
        },
        '3': {
          status: false,
          arraryPos: -1,
        },
        '4': {
          status: false,
          arraryPos: -1,
        },
      },
      allItemCollections: [],
      itemCollections1: [],
      itemCollections2: [],
      itemCollections3: [],
      itemCollections4: [],
      currentTabIndex: '1', //当前选中tab
      ruleShow: false, //规则显示
      chosenConfirm: false, //二次确认选中物品展示
      canClick: true,
      transify: null,
  
    }
  },
  computed: {
    // pk转为item内容
    pkToItem() {
      return (pk) => {
        let result = {}
        this.allItemCollections.forEach((e) => {
          if (e.pk === pk) {
            result = e
          }
        })
        return result
      }
    },
  },
  methods: {
    addGA: gaTool.addGA,
    beforeCloseConfirm(hide) {
      if (!this.canClick) {
        return
      } else {
        if (typeof hide === 'function') {
          return hide()
        }
        this.chosenConfirm = false
      }
    },
    // 指置空选中状态
    restItemCheckStatus(items) {
      items.forEach((i) => {
        i.checked = false
      })
    },
    // 规则按钮
    EvtQuestion() {
      this.ruleShow = true
    },
    // tab选中
    chooseTab(e) {
      if (e.target.dataset.tab) [(this.currentTabIndex = e.target.dataset.tab)]
    },
    // 勾选
    checkItems(tabIndex, item) {
      // 选中状态
      if (item.checked) {
        item.checked = !item.checked
      } else {
        switch (tabIndex) {
          case '1':
            this.restItemCheckStatus(this.itemCollections1)
            break
          case '2':
            this.restItemCheckStatus(this.itemCollections2)
            break
          case '3':
            this.restItemCheckStatus(this.itemCollections3)
            break
          case '4':
            this.restItemCheckStatus(this.itemCollections4)
            break
          default:
            break
        }

        item.checked = !item.checked
      }
      // 选中后推入数组
      if (item.checked) {
        this.tabCheckRecord[tabIndex]['status'] = true
        // 已有记录
        if (this.tabCheckRecord[tabIndex]['arraryPos'] > -1) {
          this.$set(this.checkedItems, this.tabCheckRecord[tabIndex]['arraryPos'], item.pk)
          // this.checkedItems[this.tabCheckRecord[tabIndex]["arraryPos"]] =item.pk;
          this.tabCheckRecord[tabIndex]['arraryPos'] = this.checkedItems.indexOf(item.pk)
        }
        // 无记录
        else {
          this.checkedItems.push(item.pk)
          this.tabCheckRecord[tabIndex]['arraryPos'] = this.checkedItems.indexOf(item.pk)
        }
      }
      //  剔除选中
      else {
        this.tabCheckRecord[tabIndex]['status'] = false
        this.checkedItems.splice(this.tabCheckRecord[tabIndex]['arraryPos'], 1)

        let indexArr = ['1', '2', '3', '4']
        indexArr.forEach((el) => {
          // if(el !== tabIndex){
          if (this.tabCheckRecord[el]['arraryPos'] > this.tabCheckRecord[tabIndex]['arraryPos']) {
            // console.log(this.tabCheckRecord[el]["arraryPos"])
            this.tabCheckRecord[el]['arraryPos'] -= 1
            // console.log(this.tabCheckRecord[el]["arraryPos"])
          }
          // }
        })
        this.tabCheckRecord[tabIndex]['arraryPos'] = -1
      }
      console.log(this.checkedItems)
    },
    EvtShowConfirm() {
      if (this.checkedItems.length === 4) {
        this.chosenConfirm = true
      }
    },
    EvtGoTask() {
      if (!this.canClick) return
      // this.$storage.setLocalStorage('wishingwellconfirm',true,'2020-04-01')
      this.canClick = false
      this.$request
        .post(this.$api.enter, { pk: this.checkedItems })
        .then((response) => {
          if (response.status !== 'success') {
            this.chosenConfirm = false
            this.ga.errorGA(response.msg)
            this.$wsMessage('network', false, true)
            return
          }
          this.$router.push({
            path: '/task',
            query: { choices: this.checkedItems },
          })
          this.chosenConfirm = false
        })
        .catch((err) => {
          this.chosenConfirm = false
          if (err === 'repeat') {
            return
          }
          utils.catchTransify(err, this.transify, this)
          this.ga.errorGA(err)

          // this.$wsMessage("network", false, true);
        })
    },
    processPkToCollections(data) {
      data.forEach((ele) => {
        switch (ele.category) {
          case 1:
            this.itemCollections1.push(ele)
            break
          case 2:
            this.itemCollections2.push(ele)
            break
          case 3:
            this.itemCollections3.push(ele)
            break
          case 4:
            this.itemCollections4.push(ele)
            break
          default:
            break
        }
      })
    },
  },
  created() {
    // let hasChose  = this.$storage.getLocalStorage('wishingwellconfirm')
    // if(hasChose){
    //   this.$router.push(`task`)
    // }
    if (this.globalConfig) {
      // th 弹窗部分
    
      if (this.globalConfig.policy_popup) {
        const {
          popup_title: policyTitle,
          popup_content: policyCtx,
          checked: policyHide,
        } = this.globalConfig.policy_popup
        this.alertShow = !policyHide
        this.alertTitle = policyTitle
        this.alertContent = policyCtx
      }

      this.userInfo = this.globalConfig.player
      this.allItemCollections = this.globalConfig.event_config.pool
      this.rule = this.globalConfig.event_config.rule
      this.transify = this.globalConfig.transify
      this.processPkToCollections(this.allItemCollections)
      let checkedItems = this.globalConfig.player_event.choices
      if (checkedItems.length > 0) {
        this.$router.push(`task`)
      }
    }
  },
}
</script>
<style lang="scss" scoped>
::-webkit-scrollbar {
  display: none;
}
.home-warp {
  width: 100vw;
  height: 100vh;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .skew-15 {
    transform: skew(-10deg);
  }
  .chosen-title {
    text-align: center;
    background: linear-gradient(top, #fbdca1, #ffd74a);
    background: -webkit-linear-gradient(top, #fbdca1, #ffd74a);
    -webkit-background-clip: text;
    color: transparent;
    @include res-size($font-size: 60px, $margin-top: 20px);
  }
  .chosen-confirm {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    @include res-size($margin-top: 10px);
    .item-gray {
      filter: brightness(0.3) contrast(91%) grayscale(100%);
    }
    .item-bg {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      @include res-size($width: 122px, $height: 122px, $margin: 25px);
      position: relative;
      // overflow-x: hidden;
    }
    .item_num {
      position: absolute;
      @include res-size($bottom: 4px, $right: 12px);
    }
    .item-name {
      @include res-size(
        $height: 30px,
        $line-height: 30px,
        $width: 122px,
        $font-size: 24px,
        $margin-left: -61px,
        $bottom: -40px
      );
      position: absolute;
      left: 50%;
      text-align: center;
      overflow: hidden;
      p {
        text-align: center;
        white-space: nowrap;
        color: #ffdd86;
      }
    }
    .item {
      @include res-size($width: 90px);
    }
    .chosen-confirm-btn {
      display: flex;
      margin-left: auto;
      margin-right: auto;
      text-align: center;
      @include res-size($width: 690px, $height: 90px, $margin-top: 50px, $font-size: 50px, $line-height: 90px);
      justify-content: space-between;
      .confirm-btn {
        @include res-size($width: 330px, $height: 90px, $line-height: 90px);
      }
      .confirm-btn-cancel {
        color: #fff5d6;
      }
      .confirm-btn-ok-txt {
        background: linear-gradient(top, #742121, #110505);
        background: -webkit-linear-gradient(top, #742121, #110505);
        -webkit-background-clip: text;
        color: transparent;
      }
    }
  }
  .home {
    height: 100%;
    align-items: center;
    display: flex;
    justify-content: center;
    flex-wrap: nowrap;
    .red-icon {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    .red-icon::after {
      background-repeat: no-repeat;
      background-size: 100% 100%;
      content: '';
      position: absolute;
      top: 0;
      @include res-size($height: 18px, $width: 18px, $right: 35px);
    }
    .left {
      @include res-size($height: 670px, $width: 644px, $padding-left: 25px, $padding-top: 89px, $margin-top: -20px);
      .tab-menu {
        position: relative;
        @include res-size($height: 63px, $width: 583px);
        .tab {
          position: absolute;
          top: 0;
          left: 0;
          @include res-size($height: 63px, $width: 162px);
        }
        .tab2 {
          @include res-size($left: 136px);
        }
        .tab3 {
          @include res-size($left: 272px);
        }
        .tab4 {
          @include res-size($left: 408px);
        }
        .tab-content {
          position: absolute;
          left: 0;
          @include res-size($top: 65px, $width: 583px, $height: 449px);
        }
      }
    }
    .item-warp {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      @include res-size($margin-top: 60px);
      .item-gray {
        filter: brightness(0.3) contrast(91%) grayscale(100%);
      }
      .item-bg {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        @include res-size($width: 122px, $height: 122px, $margin: 25px);
      }
      .item_num {
        position: absolute;
        @include res-size($bottom: 4px, $right: 12px);
      }
      .item {
        @include res-size($width: 90px);
      }
      .unCheck {
        position: absolute;
        @include res-size($bottom: 18px, $left: 18px, $width: 21px, $height: 21px);
      }
      .check {
        @include res-size($width: 29px, $height: 30px);
      }
    }
    .right {
      background-color: rgba(46, 17, 1, 0.4);
      position: relative;
      @include res-size($height: 670px, $width: 660px, $padding-left: 14px, $margin-top: -20px);
      .checked-items {
        justify-content: flex-start;
        margin-left: auto;
        margin-right: auto;
        @include res-size($margin-top: 80px, $height: 134px, $width: 584px);
        .item-bg {
          position: relative;
          @include res-size($margin: 10px);
        }
        .item_num {
          position: absolute;
          @include res-size($bottom: 4px, $right: 12px);
        }
      }
      .guide {
        margin-left: auto;
        margin-right: auto;
        // overflow-y: auto;
        @include res-size($padding: 30px, $height: 150px, $width: 496px, $margin-top: 65px);
        .content {
          color: #ffdd86;
          word-break: break-word;
          margin: 0 auto;
          overflow-y: auto;
          width: 100%;
          height: 100%;
        }
      }
      .item-static {
        @include res-size($width: 122px, $height: 122px);
      }
      .enter {
        margin-left: auto;
        margin-right: auto;
        text-align: center;
        color: #cfcdcd;
        font-style: italic;
        font-weight: 600;
        @include res-size($font-size: 60px, $height: 107px, $line-height: 107px, $width: 410px, $margin-top: 40px);
      }
      .enter-gold-text {
        font-weight: 600;
        color: #fff1da;
        position: relative;
        $font-size: 61px;
        &::after {
          content: attr('data-text');
          font-weight: inherit;
          $font-size: 60px;
          color: #7b2700;
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
        }
      }
    }
    .right::before {
      background-repeat: no-repeat;
      background-size: 100% 100%;
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      @include res-size($height: 670px, $width: 14px);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/index.vue